import { env } from '@/env';
import { Retailer } from '@/types';

interface ShortRetailerInfoProps {
  retailer: Retailer;
}

const ShortRetailerInfo = (props: ShortRetailerInfoProps) => {
  const { name, id } = props.retailer;

  return (
    <div className="max-w-[34rem] bg-secondary-grey flex text-primary-black rounded-base">
      <div className="p-1-5">
        <p className="font-bd text-2-0 text-primary-black mb-1-0 leading-1 pr-3-0">
          {name}
        </p>
        <p className="font-rg text-1-6 leading-1-5">-</p>
      </div>
      <div
        className="w-full max-w-[12.5rem] px-0-6 py-2-0 bg-white flex items-center border border-l-0 rounded-r-base border-secondary-grey"
        // style={{ backgroundColor: data.retailer?.colour || '' }}
      >
        <img src={`${env.VITE_STATIC_URL}/retailer/images/${id}-logo.png`} />
      </div>
    </div>
  );
};

export default ShortRetailerInfo;
